import React, { useMemo } from 'react'
import { useAppSelector } from '../../../../store/hooks'
import {
  selectCrossClientResultExecutionLoading,
  selectCrossClientResults,
  selectCrossClientResultsExecution,
  selectCrossClientUnableToMatchResultCount,
} from '../../../../store/crossClient/crossClientResults'
import { CrossClientClauses } from '../../Clauses/CrossClientClauses'
import { CrossClientQueryResultMatches } from '../../../../models/CrossClient'
import { CrossClientResultsOverview } from './CrossClientResultsOverview'
import { CrossClientSidebarProgress } from './CrossClientSidebarProgress'

export const CrossClientSidebar: React.FC = () => {
  const execution = useAppSelector(selectCrossClientResultsExecution)
  const results = useAppSelector(selectCrossClientResults)
  const executionLoading = useAppSelector(selectCrossClientResultExecutionLoading)
  const unableToMatchResults = useAppSelector(selectCrossClientUnableToMatchResultCount)

  const fullMatchResults = useMemo(() => results.filter((result) => result.match === CrossClientQueryResultMatches.MATCH).length, [results])
  const partialMatchResults = useMemo(() => results.filter((result) => result.match === CrossClientQueryResultMatches.PARTIAL).length, [results])

  if (executionLoading || !execution) {
    return <div className='skeleton w-100 h-25' />
  }

  const atomicClauses = execution.decomposition?.atomicClauses ?? []
  const notMatchingResults = results.length - fullMatchResults - partialMatchResults

  return (
    <div className='d-flex flex-column gap-3 zocks-p-2.0 zocks-bg-color-gray-100 h-100'>
      <CrossClientSidebarProgress
        fullMatchResults={fullMatchResults}
        partialMatchResults={partialMatchResults}
        notMatchingResults={notMatchingResults}
        unableToMatchResults={unableToMatchResults}
      />
      <div className='d-flex flex-column gap-3 px-3 py-4 border border-1 zocks-border-color-gray-200 zocks-border-1.0 bg-white'>
        <h6>Criteria</h6>
        <CrossClientClauses atomicClauses={atomicClauses} nnfDecomposition={execution.nnfDecomposition} />
      </div>
      <div className='px-3 py-4 border border-1 zocks-border-color-gray-200 zocks-border-1.0 bg-white'>
        <CrossClientResultsOverview
          fullMatchResults={fullMatchResults}
          partialMatchResults={partialMatchResults}
          notMatchingResults={notMatchingResults}
          unableToMatchResults={unableToMatchResults}
        />
      </div>
    </div>
  )
}
